import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Typography, IconButton, Box } from "@mui/material";
import { MdMenu, MdQrCodeScanner } from "react-icons/md";
import Sidebar from "../Sidebar"; // Sidebar component
import { useLocation, useNavigate } from "react-router-dom"; // For page navigation

const Header = () => {
  // Sidebar drawer state
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  // Store details and username from localStorage
  const [userDetails, setUserDetails] = useState(null);
  const [name, setName] = useState(null);

  // Used for navigation
  const navigate = useNavigate();

  // On component mount, fetch user and store info from localStorage
  useEffect(() => {
    const selectedMfr = JSON.parse(localStorage.getItem("selectedMfr"));
    const username = JSON.parse(localStorage.getItem("user"));

    if (selectedMfr) {
      setUserDetails(selectedMfr);
    }
    if (username) {
      setName(username);
    }
  }, []);

  // Function to toggle the sidebar drawer
  const toggleDrawer = (open) => (event) => {
    if (
      event?.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsDrawerOpen(open);
  };

  // Close sidebar drawer
  const handleCloseSidebar = () => {
    setIsDrawerOpen(false);
  };

  // Navigate to QR scan page
  const handleQrScanClick = () => navigate("/qrscan");

  //Title
  const { pathname } = useLocation();
  //Dynamic Header
  const pathTitleMap = {
    new: "New Orders",
    delivered: "Delivered Orders",
    ready: "Completed Orders",
    Issued: "Issued Orders",
    rejected: "Rejected Orders",
    inProcess: "In-Process Orders",
    pending: "Pending Orders",
    overdue: "Overdue Orders",
    todayDelivery: "Today's Deliveries",
    partial: "Partially Completed",
    delivertoworkshop: "Delivered to Workshop",
    order: "Create Order",
    "order-details": "Order Details",
    "order-list": "Order List",
    "my-orders": "My Orders",
    home: "Dashboard",
    qrscan: "Scan QR",
    stockscan: "Stock QR",
    filter: "Filter Data",
    filterinfo: "Filter Info",
    userlist: "User List",
    createuser: "Create User",
    createmetal: "Create Metal Type",
    createitem: "Create Item Type",
    createdesign: "Create Design",
    createstone: "Create Stone",
    bulkorder: "Create Bulk Order",
    bulkexhibitionorder: "Create Bulk Exhibition Orders",
    createdesigncatalogue: "Create Design Catalogue",
    editcatalogue: "Edit Catalogue",
  };
  const segments = pathname.split("/").filter(Boolean);
  const lastSegment = segments[segments.length - 1] || "";
  const title = pathTitleMap[lastSegment] || "App";

  return (
    <>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "#0D7377",
          backgroundImage: "linear-gradient(90deg, #0D3B3E 0%, #0A5C60 45%, #0D7377 100%)",
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "relative",
            px: { xs: 1, sm: 2 }, // padding adjusts on screen size
            minHeight: { xs: "56px", sm: "64px" },
          }}
        >
          {/* Left: Menu + Store Name */}
          <Box sx={{ display: "flex", alignItems: "center", minWidth: 0 }}>
            {name?.role !== "QC" &&
              name?.role !== "DIGITAL ORDER" &&
              name?.role !== "DIGITAL MARKETER" && (
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  sx={{ mr: 1 }}
                  onClick={toggleDrawer(true)}
                >
                  <MdMenu />
                </IconButton>
              )}

            <Typography
              variant="h6"
              noWrap
              sx={{
                display: { xs: "none", sm: "block" }, // hide on mobile, show on sm and up
                cursor: "pointer",
                fontSize: { xs: "14px", sm: "15px" },
                fontWeight: 500,
                opacity: 0.92,
                maxWidth: { xs: "120px", sm: "240px" },
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              onClick={() => navigate("/home")}
            >
              {userDetails
                ? `${userDetails?.storeDetails?.name} - ${name?.name}`
                : "Loading..."}
            </Typography>
          </Box>

          {/* Center: Title */}
          <Typography
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              fontSize: { xs: "15px", sm: "17px" },
              fontWeight: 600,
              letterSpacing: "-0.01em",
              whiteSpace: "nowrap",
            }}
          >
            {title}
          </Typography>

          {/* Right: QR Icon */}
          {name?.role !== "DIGITAL ORDER" &&
            name?.role !== "DIGITAL MARKETER" &&
            name?.role !== "Customer" && (
              <IconButton
                size="large"
                color="inherit"
                aria-label="qr-scan"
                onClick={handleQrScanClick}
              >
                <MdQrCodeScanner size={24} />
              </IconButton>
            )}
        </Toolbar>
      </AppBar>

      {/* Sidebar Drawer */}
      <Sidebar open={isDrawerOpen} onClose={handleCloseSidebar} />
    </>
  );
};

export default Header;
